<template>
  <v-layout row wrap>
    <v-flex xs12 md2 row class="ml-3">
      <v-alert class="mx-4 mt-6" color="#FF9800" dark dense prominent>
        <v-icon left>mdi-database</v-icon>
        <span class="headline">Tables</span>
      </v-alert>

      <v-card
        style="display: block"
        :color="getThemeColor"
        class="mx-4 mt-2 px-2"
        shaped
        elevation="12"
        width="144"
        v-for="(table, tind) in filteredTables"
        :key="tind + Math.random() + Math.random()"
      >
        <v-card-subtitle
          @click="getTableData(table.value)"
          style="color: white"
          >{{ table.text }}</v-card-subtitle
        >
      </v-card>
    </v-flex>
    <v-flex xs12 md2 row v-if="showColumns">
      <h5 class="mt-6">
        <v-btn
          color="indigo darken-4"
          height="45"
          dark
          @click="getSelectedColumns()"
          v-if="selectedTable"
          >Show {{ selectedTable }}</v-btn
        >
      </h5>

      <v-card
        style="display: block"
        dark
        loading
        class="mt-2"
        shaped
        elevation="12"
        width="144"
        height="60"
        v-for="(colData, innt) in tableData"
        :key="innt + Math.random() + Math.random()"
      >
        <v-checkbox
          multiple
          v-model="finalTblData"
          :value="colData"
          class="mx-2"
          :label="colData.colAppearanceText"
        ></v-checkbox>
      </v-card>
    </v-flex>
    <v-flex xs12 md9 row v-if="showTable">
      <v-card>
        <v-card-title class="mx-4">
          {{ selectedTable.toUpperCase() }}
          <v-spacer></v-spacer>
          <v-switch
            v-if="showTable"
            v-model="selectAll"
            label="Select All"
            class="ml-8 mt-4"
            @change="selectAllTableItems()"
          ></v-switch>
          <v-btn
            v-if="isAdmin || isManager"
            @click="openBulkDeleteDialog()"
            small
            rounded
            color="error"
            dark
            class="mx-4 mt-2"
            >Bulk Delete</v-btn
          >
          <v-btn
            v-if="selectedTable == 'expenses' && isManager"
            @click="openExpensesReceipts()"
            small
            rounded
            color="primary"
            dark
            class="mx-4 mt-2"
            >Expenses Receipts</v-btn
          >
          <v-btn
            v-if="
              ((selectedTable == 'live_lessons' ||
                selectedTable == 'subjects') &&
                isStaff) ||
              isAdmin
            "
            rounded
            small
            color
            class="mt-3 mx-4"
            dark
            @click="enterData()"
            >Create {{ selectedTable }}</v-btn
          >

          <v-btn
            v-if="isAdmin"
            rounded
            small
            color
            class="mt-3 mx-4"
            dark
            @click="showBulk()"
            >Bulk Edit</v-btn
          >

          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="`Search ${selectedTable.toUpperCase()}`"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-dialog v-model="dialog" min-width="900">
          <TableDialog
            :selTable="selTable"
            :tblHeaders="tblHeaders"
            :selData="selData"
            :dropdownItems="dropdownItems"
            @close-dialog="closeDialog()"
          />
        </v-dialog>
        <v-dialog v-model="dialogItem" min-width="900">
          <DatabaseEntryForm
            :selTable="selTable"
            :tblHeaders="tblHeaders"
            :entryEditData="entryEditData"
            :dropdownItems="dropdownItems"
            :saveFormDataPackage="saveFormDataPackage"
            :status="status"
            @close-dialog="closeDialogItem()"
            @data-saved="dataSaved()"
            @data-updated="dataUpdated()"
          />
        </v-dialog>

        <v-dialog v-model="bulkDelete" width="600" persistent>
          <v-card>
            <v-card-title
              :style="{ 'background-color': getThemeColor, color: 'white' }"
              class="headline lighten-2"
              >Delete Selected
              {{ selectedTable | capitalize }} items</v-card-title
            >
            <v-card-title class="mt-6 mx-4"
              >Number of Selected {{ selectedTable | capitalize }} items:
              {{ selectedTableItems.length }}</v-card-title
            >

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn rounded color="error" dark @click="deleteBulkNow()"
                >Delete Now</v-btn
              >
              <v-btn rounded color="primary" dark @click="cancelBulkDelete()"
                >Cancel</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <Loader />

        <v-data-table
          loading-text="Fetching Data"
          :search="search"
          :headers="tableHeader"
          :items="tableRows"
          :items-per-page="10"
          class="elevation-1 mx-4"
        >
          <template v-slot:item.selection="{ item }">
            <v-checkbox
              v-if="isAdmin"
              class="shrink"
              @change="getSelections()"
              :value="item.id"
              v-model="selectedTableItems"
            ></v-checkbox>
          </template>
          <template v-slot:item.id="{ item }">
            <v-icon @click="editTableItem(item)" v-if="isAdmin"
              >mdi-pencil</v-icon
            >

            <v-icon @click="deleteTableItem(item)" v-if="isAdmin"
              >mdi-delete</v-icon
            >
            <div
              v-else-if="
                (selectedTable == 'live_lessons' ||
                  selectedTable == 'subjects') &&
                isStaff
              "
            >
              <v-icon @click="editTableItem(item)">mdi-pencil</v-icon>
              <v-icon @click="deleteTableItem(item)">mdi-delete</v-icon>
            </div>

            <v-btn
              v-for="(rtable, rind) in relatedTables"
              :key="rind + Math.random() + Math.random()"
              :color="btnColors[rind]"
              class="mx-1"
              rounded
              x-small
              dark
              @click="showRelTable(rtable, item)"
              >{{ rtable }}</v-btn
            >

            <v-btn
              v-if="
                selectedTable == 'live_lessons' || selectedTable == 'subjects'
              "
              color="green accent-4"
              class="mx-1"
              rounded
              x-small
              dark
              @click="joinLiveLesson(item)"
              >Join Now</v-btn
            >
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "@/plugins/axios";
import Loader from "@/components/Loader.vue";
import TableDialog from "@/components/myLibrary/TableDialog.vue";
import DatabaseEntryForm from "@/components/myLibrary/DatabaseEntryForm.vue";

export default {
  props: ["tables"],
  mounted() {
    this.filteredTables = this.tables.filter((tabl) => {
      return tabl.alevel.includes(Number(this.getCurrentUser.alevel));
    });

    this.$store.commit("setLoader", true);
    axios
      .getData("/auth/initialise-income-and-expense-cats", this.getAccessToken)
      .then((response) => {
        response = response + " wow";
        this.$store.commit("setLoader", false);
      });
  },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getCurrentDate() {
      return axios.getCurrentDate();
    },
  },

  components: {
    Loader,
    TableDialog,
    DatabaseEntryForm,
  },
  data() {
    return {
      filteredTables: [],
      pdf: "",
      queryFilter: "1=1",
      status: null,
      selectedTable: null,
      selectedTableItems: [],
      showColumns: false,
      tableHeader: [],
      tableRows: [],
      showTable: false,
      selectAll: false,
      search: "",
      dialog: false,
      bulkDelete: false,
      dialogItem: false,
      dialogRels: false,
      dropdownItems: [],
      selCols: [],
      selData: [],
      entryEditData: {},
      tblHeaders: [],
      saveFormDataPackage: [],
      relatedTables: [],
      tableData: [],
      finalTblData: [],
      selTable: null,
      btnColors: [
        "#3dc7be",
        "indigo darken-4",
        "amber darken-4",
        "blue-grey darken-4",
        "orange accent-4",
        "yellow accent-4",
        "light-green accent-4",
        "pink darken-3",
      ],
    };
  },
  methods: {
    openBulkDeleteDialog() {
      if (this.selectedTableItems.length < 1) {
        alert("You Must Select At least One(1) Item!");
        event.preventDefault();
      } else {
        this.bulkDelete = true;
      }
    },
    openExpensesReceipts() {
      if (this.selectedTableItems.length < 1) {
        alert("You Must Select At least One(1) Item!");
        event.preventDefault();
      } else {
        this.$router.push({
          name: "expense-receipts",
          params: { ids: this.selectedTableItems },
        });
      }
    },
    deleteBulkNow() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/bulk-delete",
          { table: this.selectedTable, rowIds: this.selectedTableItems },
          this.getAccessToken
        )
        .then((response) => {
          if (response == "success") {
            this.$store.commit("setLoader", false);
            this.bulkDelete = false;
            this.getSelectedColumns();
            this.selectedTableItems = [];
          }
        });
    },
    cancelBulkDelete() {
      this.selectedTableItems = [];
      this.bulkDelete = false;
    },
    dataSaved() {
      this.snackBarText = "Data Saved Successfully";
      this.snackBar = true;
      setTimeout(this.closeDialogItem, 2000);
    },
    dataUpdated() {
      this.snackBarText = "Data Updated Successfully";
      this.snackBar = true;
      setTimeout(() => {
        this.snackBar = false;
      }, 2000);
    },
    showRelTable(rtable, item) {
      this.selTable = rtable;
      this.tblHeaders = this.getTableDialogCols(this.selTable);
      this.selData = [item];
      this.getDropdownItems(this.selTable);
    },
    showBulk() {
      this.$store.commit("setLoader", true);
      this.selTable = this.selectedTable;
      this.tblHeaders = this.getTableDialogCols(this.selTable);
      this.selData = this.tableRows;
      this.getDropdownItems(this.selTable);
    },
    getDropdownItems(table) {
      axios
        .postDataWithToken(
          "/auth/get-dependent-table-columns",
          { table: table },
          this.getAccessToken
        )
        .then((response) => {
          this.$store.commit("setLoader", false);
          this.dropdownItems = response;
          this.dialog = true;
        });
    },
    enterData() {
      this.selTable = this.selectedTable;
      this.tblHeaders = this.getTableDialogCols(this.selTable);
      this.getDropdownItemsForm(this.selTable);
      this.entryEditData = {};
      this.dialogItem = true;
      this.status = "new";
    },
    closeDialogItem() {
      this.dialogItem = false;
      this.getSelectedColumns();
    },
    deleteTableItem(item) {
      if (confirm("Are you sure you want to delete this item?")) {
        axios
          .postDataWithToken(
            "/auth/delete-item",
            { table: this.selectedTable, id: item.id },
            this.getAccessToken
          )
          .then((response) => this.getSelectedColumns());
      }
    },
    getSelectedColumns() {
      this.$store.commit("setLoader", true);
      this.showColumns = false;
      this.showTable = true;
      this.tableHeader = [{ value: "selection" }];

      this.finalTblData.forEach((colD) => {
        this.tableHeader.push({
          text: colD.colAppearanceText,
          value: colD.retrievalKey,
        });
      });
      this.tableHeader.push({ text: "Actions", value: "id" });
      axios
        .postDataWithToken(
          "/auth/get-table-columns",
          { table: this.selectedTable, queryFilter: this.queryFilter },
          this.getAccessToken
        )
        .then((response) => {
          this.$store.commit("setLoader", false);
          this.tableRows = response;
        });
    },
    getDropdownItemsForm(table) {
      axios
        .postDataWithToken(
          "/auth/get-dependent-table-columns",
          { table: table },
          this.getAccessToken
        )
        .then((response) => {
          this.$store.commit("setLoader", false);
          this.dropdownItems = response;
          this.dialogItem = true;
        });
    },

    editTableItem(item) {
      this.selTable = this.selectedTable;
      this.tblHeaders = this.getTableDialogCols(this.selTable);
      this.getDropdownItemsForm(this.selTable);
      this.entryEditData = item;
      this.dialogItem = true;
      this.status = "edit";
    },

    closeDialog() {
      this.dialog = false;
      this.getSelectedColumns();
    },
    getSelections() {
      //console.log(this.selectedTableItems);
    },
    getColumns() {
      this.finalTblData = [];
      this.$store.commit("setLoader", false);
      axios
        .postDataWithToken(
          "/auth/get-table-column",
          { table: this.selectedTable },
          this.getAccessToken
        )
        .then((response) => {
          this.showColumns = true;
          this.showTable = false;
          this.tableData = [];
          this.relatedTables = [];

          const keyValuePairs = Object.entries(response);

          keyValuePairs.forEach((columnData) => {
            if (columnData[0] == "id" || columnData[0] == "emis") {
              return;
            } else if (
              columnData[1] != null &&
              typeof columnData[1] == "object"
            ) {
              const tbl = columnData[0];
              this.relatedTables.push(tbl);
              const columns = Object.keys(columnData[1]);
              columns.forEach((column) => {
                if (column == "id" || column == "emis") {
                  return;
                }
                const colspace = column.replace("_", " ");
                this.tableData.push({
                  table: tbl,
                  column: column,
                  colAppearanceText: colspace.toUpperCase(),
                  retrievalKey: tbl + "." + column,
                  tableId: tbl + ".id",
                });
              });
            } else {
              const tbl = this.selectedTable;
              const column = columnData[0];
              const colspace = column.replace("_", " ");
              this.tableData.push({
                table: tbl,
                column: column,
                colAppearanceText: colspace.toUpperCase(),
                retrievalKey: column,
                tableId: tbl + ".id",
              });
            }
          });
          this.finalTblData = this.tableData;
          this.$store.commit("setLoader", false);
        });
    },

    getTableDialogCols(selTable) {
      axios
        .postDataWithToken(
          "/auth/get-columns",
          { table: selTable },
          this.getAccessToken
        )
        .then((response) => {
          this.tblHeaders = response;
          this.tblHeaders.splice(this.tblHeaders.indexOf("id"), 1);
          this.tblHeaders.splice(this.tblHeaders.indexOf("emis"), 1);
        });
    },
    selectAllTableItems() {
      if (this.selectAll) {
        this.selectedTableItems = [];
        this.tableRows.forEach((row) => {
          this.selectedTableItems.push(row.id);
        });
      } else {
        this.selectedTableItems = [];
      }
    },
    getTableData(table) {
      this.selectedTable = table;
      this.getColumns();
    },
    joinLiveLesson(item) {
      this.$router.push({ name: "live-videos", params: { lesson: item } });
    },
  },
  filters: {
    capitalize(item) {
      return item.toUpperCase();
    },
  },
};
</script>

<style></style>
